<template>
  <b-container class="text-block imprint">
    <b-row>
      <b-col>
        <h2>Impressum</h2>
        <p class="text-muted">
          Inhaltlich verantwortlich nach § 5 Digitale-Dienste-Gesetz (DDG) und §
          18 Abs. 2 Medienstaatsvertrag (MStV)
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="8">
        <b-card class="imprint-card" body-class="p-4">
          <p class="imprint-name">Elisabeth Dauphin</p>

          <ul class="imprint-details list-unstyled">
            <li>
              <b-icon-geo-alt></b-icon-geo-alt>
              <address class="mb-0">
                August-Bebel-Str. 66<br />
                99974 Mühlhausen
              </address>
            </li>
            <li>
              <b-icon-telephone></b-icon-telephone>
              <a href="tel:+4917664614205">0176 / 646 14 205</a>
            </li>
            <li>
              <b-icon-envelope></b-icon-envelope>
              <a href="mailto:elisabeth.dauphin@ekmd.de"
                >elisabeth.dauphin@ekmd.de</a
              >
            </li>
          </ul>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col lg="8">
        <p class="text-muted">
          Das Impressum gilt auch für die Social-Media-Präsenzen auf Facebook
          und Instagram.
        </p>
        <b-card class="imprint-card" body-class="p-4">
          <ul class="imprint-details list-unstyled">
            <li>
              <strong>Facebook</strong>
              <a
                href="https://www.facebook.com/JugendkircheMHL/"
                target="_blank"
                rel="noopener noreferrer"
                >https://www.facebook.com/JugendkircheMHL/</a
              >
            </li>
            <li>
              <strong>Instagram</strong>
              <a
                href="https://www.instagram.com/jugendkirche.muehlhausen/"
                target="_blank"
                rel="noopener noreferrer"
                >https://www.instagram.com/jugendkirche.muehlhausen/</a
              >
            </li>
          </ul>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Imprint"
};
</script>

<style lang="scss" scoped>
.imprint {
  margin-top: 100px;
  margin-bottom: 80px;
}

.imprint-card {
  border-left: 4px solid #d9230f;
}

.imprint-name {
  font-weight: bold;
  font-size: 1.15rem;
  margin-bottom: 1rem;
}

.imprint-details {
  li {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    margin-bottom: 0.75rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  svg {
    flex-shrink: 0;
    margin-top: 0.2rem;
    color: #d9230f;
  }

  address {
    font-style: normal;
  }
}
</style>
